import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Card, CardHeader, CardContent, Typography, Grid } from '@material-ui/core';

const CustomCard = ({ classes, title, titleAction, actions, children, noShadow, noBox }) => {
  return (
    <Fragment>
      {title && (
        <Grid container justify="space-between">
          <Typography variant="h3" paragraph>
            {title}
          </Typography>
          {titleAction}
        </Grid>
      )}
      <Card classes={{ root: cx(classes.card, noShadow && classes.noShadow, noBox && classes.noBox) }}>
        {actions && <CardHeader action={actions} classes={{ root: classes.header, action: classes.action }} />}
        <CardContent classes={{ root: classes.content }}>{children}</CardContent>
      </Card>
    </Fragment>
  );
};

CustomCard.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** The title of the Card. */
  title: PropTypes.string,
  /** The content of the Card. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  noShadow: PropTypes.bool,
  // disable paddings, margins and border
  noBox: PropTypes.bool,
};

CustomCard.defaultProps = {
  classes: {},
};

export default CustomCard;
